<button type="button" (click)="connectWallet()" class="btn btn-primary btn-block" rippleEffect>
    <i data-feather="credit-card" class="mr-1"></i>Connect Metamask wallet
</button>